import api from './api';

const feedbackService = {
  // Submit feedback for a message
  submitFeedback: async (messageId, feedbackType, reason = '', additionalInfo = '', aiResponse = '', chatId = '') => {
    try {
      const response = await api.post('/api/feedback/submit', {
        messageId,
        feedbackType,
        reason,
        additionalInfo,
        aiResponse,
        chatId
      });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  // Get feedback for a specific message
  getMessageFeedback: async (messageId) => {
    try {
      const response = await api.get(`/api/feedback/message/${messageId}`);
      return response.data;
    } catch (error) {
      if (error.response?.status === 404) {
        return null; // No feedback found
      }
      console.error('Error getting message feedback:', error);
      throw error.response?.data || error;
    }
  },

  // Get all feedback for the current user
  getUserFeedback: async (page = 1, limit = 10, feedbackType = null) => {
    try {
      const params = { page, limit };
      if (feedbackType) {
        params.feedbackType = feedbackType;
      }

      const response = await api.get('/api/feedback/user', { params });
      return response.data;
    } catch (error) {
      console.error('Error getting user feedback:', error);
      throw error.response?.data || error;
    }
  },

  // Delete feedback
  deleteFeedback: async (feedbackId) => {
    try {
      const response = await api.delete(`/api/feedback/${feedbackId}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting feedback:', error);
      throw error.response?.data || error;
    }
  }
};

export default feedbackService;
